import { Container, Typography } from "@mui/material";

function Terminal() {
  return (
    <Container sx={(theme) => ({ paddingY: theme.spacing(3) })}>
      <Typography variant="overline" tag="p" gutterBottom>
        Coming Soon
      </Typography>
      <Typography variant="h4" tag="div">
        Terminal
      </Typography>
    </Container>
  );
}

export default Terminal;
